module.exports = __webpack_public_path__ + "141a0fccfa552462a946691b37731457.svg";